module.exports = __webpack_public_path__ + "img/ringDiameter@2x.85eef04.webp";